<template>
  <ion-page>
    <ion-content class="legal-document-content" :fullscreen="true">
      <StickyPageHeader :title="doc.title" @back="closeModal" />

      <div class="legal-document-container">
        <div class="legal-hero">
          <img :src="legalHero" alt="" class="legal-hero-img" />
        </div>

        <p v-if="doc.subtitle" class="legal-subtitle">{{ doc.subtitle }}</p>

        <div class="legal-date">
          <ion-icon :icon="calendarOutline" class="legal-date-icon" />
          <span>{{ doc.date }}</span>
        </div>

        <section
          v-for="(section, index) in doc.sections"
          :key="index"
          class="legal-section"
        >
          <h2 class="legal-section-heading">{{ section.heading }}</h2>
          <p
            v-for="(paragraph, paragraphIndex) in section.paragraphs"
            :key="paragraphIndex"
            class="legal-section-text"
          >
            {{ paragraph }}
          </p>
        </section>
      </div>
    </ion-content>
  </ion-page>
</template>

<script setup>
import { computed, onMounted, onBeforeUnmount } from 'vue';
import { IonPage, IonContent, IonIcon, modalController } from '@ionic/vue';
import { useStore } from 'vuex';
import { calendarOutline } from 'ionicons/icons';
import StickyPageHeader from '@/components/ui/StickyPageHeader.vue';
import { legalDocuments } from '@/data/legalDocuments';
import legalHero from '@/assets/legal/legal-hero.png';

const props = defineProps({
  documentKey: {
    type: String,
    required: true,
  },
});

const store = useStore();

onMounted(() => {
  store.commit('ui/incrementOverlay');
});

onBeforeUnmount(() => {
  store.commit('ui/decrementOverlay');
});

const doc = computed(() => legalDocuments[props.documentKey] || legalDocuments.agb);

const closeModal = () => modalController.dismiss();
</script>

<style lang="scss" scoped>
.legal-document-content {
  --background: #fff;
}

.legal-document-container {
  max-width: 600px;
  margin: 0 auto;
  padding: 0 16px 32px;
}

.legal-hero {
  display: flex;
  justify-content: center;
  margin-bottom: 12px;
}

.legal-hero-img {
  width: 100%;
  max-width: 280px;
  height: auto;
  display: block;
}

.legal-subtitle {
  margin: 0 0 12px;
  font-size: 18px;
  font-weight: 400;
  line-height: 1.4;
  color: #1a1a1a;
  text-align: center;
}

.legal-date {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 6px;
  margin-bottom: 20px;
  font-size: 16px;
  font-weight: 400;
  color: #1a1a1a;
}

.legal-date-icon {
  font-size: 18px;
  color: #1a1a1a;
}

.legal-section {
  margin-bottom: 24px;
}

.legal-section-heading {
  margin: 0 0 12px;
  font-size: 24px;
  font-weight: 400;
  line-height: 1.3;
  color: #1a1a1a;
}

.legal-section-text {
  margin: 0 0 12px;
  font-size: 18px;
  font-weight: 400;
  line-height: 1.45;
  color: #1a1a1a;

  &:last-child {
    margin-bottom: 0;
  }
}
</style>
